/**
 * Trunnion AI - Agent Chat Page
 */

import { useParams } from 'react-router-dom';
import { AgentChatView } from '@/components/chat/AgentChatView';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';

export default function AgentChatPage() {
  const { id } = useParams<{ id: string }>();

  const { data: agent, isLoading } = useQuery({
    queryKey: ['agents', id],
    queryFn: async () => {
      const { data } = await apiClient.get(`/agents/${id}`);
      return data;
    },
    enabled: !!id,
  });

  if (isLoading || !agent) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingSpinner label="Loading agent..." />
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-8rem)]">
      <AgentChatView
        agentId={id!}
        agentName={agent.name}
        agentTier={agent.tier}
        modelName={agent.llmModelId ?? agent.llmModel}
      />
    </div>
  );
}
